import React, { useState, useEffect } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
// import MonthlyQuotation from "./MonthlyQuotationTemplate/MonthlyQuotation";
import { CgSpinner } from "react-icons/cg";
import JobEnquiryPdfs from "./DownloadJobEnquiry/JobEnquiryPdf";
import { axios } from "../../../../../../Global";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";

const RecAgencyDownloadPupup = ({
  openGenerateQuotation,
  setOpenGenerateQuotation,
  InitialSelectedTItles,
  list,
}) => {
  const [TableRowLists, setTableRowLists] = useState([]);
  const [checkboxArray, setCheckboxArray] = useState([
    {
      col: "Actual Profession",
      title: "actual_profession",
    },
    {
      col: "Visa Profession",
      title: "visa_profession",
    },
    {
      col: "Profession Level",
      title: "profession_level",
    },
    {
      col: "Gender",
      title: "gender",
    },
    {
      col: "Nationality",
      title: "nationality",
    },
    {
      col: "Quantity",
      title: "quantity",
    },
  ]);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const [GenerateList, setGenerateList] = useState(InitialSelectedTItles);
  const [disableCheckbox, setDisableCheckbox] = useState(false);
  const [onChangeValue, setOnchangeValue] = useState({ obj: {}, value: "" });
  const [notesData, setNotesData] = useState([]);
  const [termsData, setTermsData] = useState([]);
  const [pdfDetails, setPdfDetails] = useState();
  const [enquiryHeading, SetEnquiryHeading] = useState([]);
  const [actualProfession, setActualProfesston] = useState([]);
  const [visaProfession, setVisaProfession] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [professionLevel, setProfessionLevel] = useState([]);

  const [loading, setLoading] = useState(true);

  const callPdfData = async () => {
    try {
      const res = await axios.get(
        `/dashboard/project-job-enquiry/${openGenerateQuotation?.rowId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.status == 200) {
        setLoading(false);
        const data = res.data.data;
        console.log(
          data?.job_enquiry?.project_job_enquiry_recruitment,
          "enquiry detials"
        );
        setPdfDetails(data?.job_enquiry);
        setActualProfesston(data?.job_possition);
        setVisaProfession(data?.visa_profession);
        setNationality(data?.nationality);
        setProfessionLevel(data?.profession_level);
        SetEnquiryHeading(
          data.job_enquiry.project_job_enquiry_cost_sheet_heading
        );
        setTermsData(data?.job_enquiry?.project_job_enquiry_term);
        setNotesData(data?.job_enquiry?.project_job_enquiry_note);
        let jobEnquiryHeadings = [];
        data.job_enquiry.project_job_enquiry_cost_sheet_heading?.forEach(
          (heading) => {
            jobEnquiryHeadings.push({
              col: heading.heading_name,
              title: String(heading.heading_name)
                .trim()
                .split(" ")
                .join("_")
                .toLowerCase(),
            });
          }
        );
        setCheckboxArray([
          ...checkboxArray,
          ...jobEnquiryHeadings,
          {
            col: "Total Monthly Per Head Cost",
            title: "total_monthly_cost_head",
          },
        ]);
      }
    } catch (error) {
      setLoading(false);

      console.log(error);
      dispatch(setAppError({ msg: error.message }));
    }
  };

  useEffect(() => {
    callPdfData();
  }, []);

  const pdfDetailsGeneration = () => {
    let tableArrays = [];
    let tableRowData = {};
    let basicInfo =
      pdfDetails?.project_job_enquiry_cost_sheet_profession_basic_information;
    let costSheetDetails =
      pdfDetails?.project_job_enquiry_cost_sheet_cost_detail;
    let costSheetHeading = pdfDetails?.project_job_enquiry_cost_sheet_heading;
    basicInfo?.forEach((item) => {
      tableRowData.actual_profession = actualProfession?.filter(
        (profession, index) => item.job_position_id == profession?.id
      )[0].name;
      tableRowData.gender = item?.gender;
      tableRowData.visa_profession = visaProfession?.filter(
        (visa, index) => item.visa_profession_id == visa?.id
      )[0].name;
      tableRowData.profession_level = professionLevel?.filter(
        (level, index) => item.profession_level_id == level?.id
      )[0].name;
      tableRowData.quantity = item?.quantity;
      tableRowData.nationality = nationality?.filter(
        (country, index) => item.nationality_id == country?.id
      )[0].name;
      let costSheetTotalCost = 0;
      costSheetDetails?.forEach((cost) => {
        if (
          cost?.project_job_enquiry_cost_sheet_profession_basic_information_id ==
          item.id
        ) {
          costSheetHeading?.forEach((heading, headIndex) => {
            if (
              cost?.project_job_enquiry_cost_sheet_heading_id == heading?.id
            ) {
              costSheetTotalCost =
                Number(costSheetTotalCost) + Number(cost?.cost);
              // basic

              tableRowData[
                String(heading?.heading_name)
                  .trim()
                  .split(" ")
                  .join("_")
                  .toLowerCase()
              ] = cost?.cost;
            }
          });
        }
      });

      tableRowData.total_monthly_cost_head = costSheetTotalCost;

      tableRowData.total_monthly_cost_head =
        Number(costSheetTotalCost).toFixed(2);
      tableArrays.push(tableRowData);
      tableRowData = {};
    });
    setTableRowLists(tableArrays);
  };

  useEffect(() => {
    pdfDetailsGeneration();
  }, [pdfDetails]);

  useEffect(() => {
    const name = onChangeValue.obg?.col;
    const value = onChangeValue.value;
    if (GenerateList.length === 9 && value === true) {
      setDisableCheckbox(true);

      const filteredArray = GenerateList.filter((item) => item?.col !== name);

      setGenerateList(filteredArray);
    } else {
      setDisableCheckbox(false);
      if (value === true) {
        setGenerateList((prev) => [...prev, onChangeValue.obg]);
      } else {
        const filteredArray = GenerateList.filter((item) => item?.col !== name);

        setGenerateList(filteredArray);
      }
    }
  }, [onChangeValue]);

  useEffect(() => {
    if (GenerateList.length >= 3 && GenerateList.length <= 9) {
      const isTotalMonthly = GenerateList?.filter(
        (item) => item.col === "Total Monthly Per Head Cost"
      );
      if (
        isTotalMonthly.length !== 0 &&
        GenerateList[GenerateList.length - 1].col !==
          "Total Monthly Per Head Cost"
      ) {
        const filteredArray = GenerateList?.filter(
          (item) => item.col !== "Total Monthly Per Head Cost"
        );
        const copiedArray = [...filteredArray];
        copiedArray.push({
          col: "Total Monthly Per Head Cost",
          title: "total_monthly_cost_head",
        });
        setGenerateList(copiedArray);
      }
    }
  }, [GenerateList]);

  const OnChangeHandler = (value, item) => {
    setOnchangeValue({ obg: item, value: value });
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        openGenerateQuotation ? "flex" : "hidden"
      }`}
    >
      <form className="max-w-3xl w-full h-auto   bg-white  rounded-md p-5">
        <h2 className="text-lg font-bold">CHOOSE FIELDS</h2>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p className="text-sm">select fields between 3 to 9</p>
          <p className="text-xs font-semibold text-slate-600">
            {GenerateList.length + "/9 Selected"}
          </p>
        </div>
        {!loading ? (
          <div className="my-4 grid grid-cols-2 gap-2 uppercase overflow-y-scroll max-h-[20rem]">
            {checkboxArray?.map((item, index) => (
              <div key={index} className="form-control w-fit">
                <label className="cursor-pointer label">
                  <input
                    disabled={
                      disableCheckbox &&
                      !GenerateList.some((check) => check.col == item.col)
                    }
                    onChange={(e) => OnChangeHandler(e.target.checked, item)}
                    type="checkbox"
                    checked={GenerateList.some(
                      (check) => check.col == item.col
                    )}
                    className="checkbox  checkbox-accent"
                  />
                  <span className="label-text ml-2 font-semibold font-lg">
                    {item.col}
                  </span>
                </label>
              </div>
            ))}
          </div>
        ) : (
          <LoadingWithLable />
        )}
        <div className="flex gap-3 justify-center items-center m-5">
          <button
            className="p-2 w-20 rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenGenerateQuotation(false);
            }}
          >
            CANCEl
          </button>
          {GenerateList.length >= 3 && GenerateList.length <= 9 ? (
            <button
              type="button"
              onClick={() =>
                setTimeout(() => {
                  setOpenGenerateQuotation(false);
                })
              }
              className="p-2 bg-blue text-white rounded-md"
            >
              <PDFDownloadLink
                document={
                  <JobEnquiryPdfs
                    data={pdfDetails}
                    generatedTitles={GenerateList}
                    TableRowLists={TableRowLists}
                    TermsConditions={termsData}
                    notes={notesData}
                    modeOfRecruitment={
                      pdfDetails?.project_job_enquiry_recruitment
                    }
                    jobDescription={pdfDetails?.project_job_enquiry_description}
                  />
                }
                fileName={`Job_Enquiry-${pdfDetails?.job_enquiry_number}`}
              >
                {({ blob, url, loading, error }) =>
                  loading ? (
                    <p className="flex gap-3 items-center">Submit</p>
                  ) : (
                    <p className="flex gap-3 items-center">Submit</p>
                  )
                }
              </PDFDownloadLink>
            </button>
          ) : (
            <button
              className="p-2 bg-blue text-white rounded-md opacity-50"
              disabled
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default RecAgencyDownloadPupup;
